import { Fragment } from "react";

import Box from "@/components/Box";
import Divider from "@/components/Divider";
import { ExternalTextLink } from "@/components/Links";
import Loading from "@/components/Loading";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_TEST_RESULT_URL, getCmpUrl } from "@/core/urls";
import ChevronComponent from "@/tpo/Chevron";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

import { dashboardActionButtonSize } from "../learningHub/dashboardLayout";
import {
  cmpHomeDashboardEmptyMessage,
  cmpHomeDashboardListInnerStackGap,
  cmpHomeDashboardListPrimary,
  cmpHomeDashboardListRowPy,
  cmpHomeDashboardListSecondary,
  cmpHomeDashboardSectionRowGap
} from "./dashboardLayout";

export default function ResultsToViewList({
  userTests,
  loading,
  emptyMessage = "No new results available"
}) {
  const { organisation } = useOrganisationContext();
  const organisationId = organisation?.hashId;

  if (loading && !userTests?.length) {
    return <Loading />;
  }

  if (!userTests?.length) {
    return <Box {...cmpHomeDashboardEmptyMessage}>{emptyMessage}</Box>;
  }

  return (
    <>
      {userTests.map((userTest, index) => (
        <Fragment key={userTest.id}>
          <Group
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            gap={cmpHomeDashboardSectionRowGap}
            py={cmpHomeDashboardListRowPy}
          >
            <Stack gap={cmpHomeDashboardListInnerStackGap} flex="1" minWidth={0}>
              <Box {...cmpHomeDashboardListPrimary}>{userTest.user.fullName}</Box>
              <Box {...cmpHomeDashboardListSecondary}>{userTest.testProduct?.name}</Box>
            </Stack>
            <ButtonV2
              color="green"
              rightIcon={<ChevronComponent />}
              as={ExternalTextLink}
              underline={false}
              href={getCmpUrl(CMP_PATIENTS_TEST_RESULT_URL, {
                patientId: userTest.user.id,
                userTestId: userTest.id,
                organisationId
              })}
              size={dashboardActionButtonSize}
              flexShrink={0}
            >
              review
            </ButtonV2>
          </Group>
          {index < userTests.length - 1 ? <Divider /> : null}
        </Fragment>
      ))}
    </>
  );
}
